var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main",style:({ backgroundColor: _vm.bgc })},[_c('div',{staticClass:"head"},[_c('div',{staticClass:"h-logo",on:{"click":function($event){return _vm.nav()}}},[_c('img',{attrs:{"src":require("@/assets/images/public/NFTCN-logo.png"),"alt":"logo"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }